import React from 'react';
import { useNavigate } from 'react-router-dom';
import { hasModuleAccess } from '../utils/textUtils';

/**
 * Displays an "Access Restricted" UI when the user does not have permission.
 */
// MODIFIED: Added isAllowed and restrictedMessage props for feature-flagging support
export const AccessRequired = ({
  userAccess,
  moduleName = "",
  pathName = "",
  className,
  isAllowed = true,           // ADDED: Defaults to true for backward compatibility
  restrictedMessage = ""      // ADDED: Custom message for client-specific restrictions
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (pathName) {
      navigate(pathName);
    }
  };

  const allowedModuleAccess = hasModuleAccess(userAccess, moduleName);

  return (
    <div className={`fixed inset-0 z-[9999] bg-white flex items-center justify-center w-screen h-screen ${className ?? ''}`}>
      <div className="flex flex-col items-center justify-center p-8 text-center bg-white border border-gray-200 rounded-xl">

        {/* Image Section */}
        <div className="mb-6 w-full flex justify-center">
          <img
            src="/images/404_pageNoAccess.svg"
            alt="Access Restricted"
            className="h-64 w-auto max-w-full object-contain drop-shadow-sm"
          />
        </div>

        {/* Text Section */}
        <div className="max-w-md space-y-2">
          <h3 className="text-xl font-bold text-blue-600">
            {/* MODIFIED: Header text changes if the module is disabled at client level */}
            {isAllowed ? "Access Restricted" : "Module Unavailable"}
          </h3>

          <p className="text-gray-500">
            {/* MODIFIED: Show custom restricted message or default permission message */}
            {!isAllowed
              ? (restrictedMessage || "This module is not enabled for your organization.")
              : "You do not have permission to view this module | module doesn't exist."
            }
          </p>

          {/* Configuration Section (Only show if module is allowed/enabled) */}
          {/* MODIFIED: Wrapped in isAllowed check */}
          {isAllowed && allowedModuleAccess && moduleName && (
            <div className="mt-6 pt-4 border-t border-gray-100">
              <div className="inline-block px-4 py-2 bg-blue-50 text-blue-800 text-sm rounded-lg border border-blue-100">
                <span className="text-blue-600 mr-1">Configuration required at:</span>

                {pathName ? (
                  <span
                    onClick={handleClick}
                    className="font-bold block sm:inline text-blue-700 hover:underline cursor-pointer"
                  >
                    {moduleName}
                  </span>
                ) : (
                  <span className="font-bold block sm:inline">
                    {moduleName}
                  </span>
                )}
              </div>
            </div>
          )}

          {/* Contact Admin / Go Home Section */}
          {/* MODIFIED: Shows if permission is denied OR if module is disabled globally */}
          {(!allowedModuleAccess || !isAllowed) && (
            <div className="mt-6 pt-4 border-t border-gray-100 flex flex-col items-center">
              {isAllowed && (
                <div className="inline-block px-4 py-2 bg-blue-50 text-blue-800 text-sm rounded-lg border border-blue-100 mb-4">
                  <span className="text-blue-600 mr-1">Please Contact your Administrator for access.</span>
                </div>
              )}

              {/* HOME LINK */}
              <div className="mt-2">
                <span
                  onClick={() => window.location.pathname = "/"}
                  className="text-blue-600 text-sm font-bold hover:underline cursor-pointer flex items-center gap-1"
                >
                  ← Go Back Home
                </span>
              </div>
            </div>
          )}
        </div>

      </div>
    </div>
  );
};